import React from 'react';
import CarerType from './CarerType';
import { CarerTabProps } from './types';

const CarerTabs = ({
  showNurse,
  showDoctor,
  onDoctorClick,
  onNurseClick,
}: CarerTabProps) => {
  return (
    <>
      <CarerType
        showBottomLine={showNurse}
        carerType={'Nurse (ACP)'}
        onClick={onNurseClick}
      ></CarerType>
      <CarerType
        showBottomLine={showDoctor}
        carerType={'GP'}
        onClick={onDoctorClick}
      ></CarerType>
    </>
  );
};

export default CarerTabs;
